export default __webpack_public_path__ + "static/media/logo-conexa-dark.a3b17eff.png";